<template>
  <CardToolbox>
    <sdPageHeader :title="locale.page.teamList.title">
      <template #subTitle>
        <span class="title-counter">{{ count }} team{{ count > 0 && count < 2 ? '' : 's' }}</span>
        <AutoCompleteStyled style="width:100%" placeholder="Zoeken op naam...">
          <a-input type="input" v-model:value="search">
            <template #suffix>
              <sdFeatherIcons type="search"/>
            </template>
          </a-input>
        </AutoCompleteStyled>
      </template>
      <template #buttons>
        <TeamAdd v-if="$can('create', 'team')"/>
      </template>
    </sdPageHeader>
  </CardToolbox>
  <Main>
    <a-row :gutter="15">
      <a-col :md="24">
        <TeamTable/>
      </a-col>
    </a-row>
  </Main>
</template>
<script>
import TeamTable from './component/TeamTable';
import {computed, ref, defineComponent, onMounted, watch} from 'vue';
import {useStore} from 'vuex';
import {Main, CardToolbox, AutoCompleteStyled} from '../styled';
import TeamAdd from "./TeamAdd";
import locale from "@/static/locale/nl.json";

const TeamList = defineComponent({
  name: 'TeamList',
  components: {TeamAdd, Main, CardToolbox, TeamTable, AutoCompleteStyled},
  data() {
    return {
      showEditDrawer: false,
    }
  },
  setup() {
    const {state, dispatch} = useStore();
    const searchData = computed(() => state.headerSearchData);
    const count = computed(() => state.team.count);
    const selectedRowKeys = ref(0);
    const selectedRows = ref(0);
    const search = ref(state.team.listQuery?.q ?? null);
    let debounce = null;

    watch(search, (query) => {
      clearTimeout(debounce)
      debounce = setTimeout(async () => {
        const searchValues = {
          q: query,
          pageSize: state.team.pageSize,
          page: 1,
        };
        await dispatch('setCurrentPageTeams', 1);
        await dispatch('getTeams', searchValues);
      }, 600);
    });

    onMounted(() => {
      dispatch('getTeams', {page: state.team.currentPage, pageSize: state.team.pageSize});
    });

    return {
      searchData,
      selectedRowKeys,
      selectedRows,
      count,
      locale,
      search,
    };
  },
});

export default TeamList;
</script>
